import { faArrowLeft, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import Icon from "../components/Icon";
import Container from "../layout/Container";
import Input from "../components/elements/Input";
import Hotel from "../assets/images/card/property.png";
import Navbar from "../layout/Navbar";
import useWidth from "../hooks/useWidth";
import MobileView from "../pages/mobile/Confirm&Pay";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import { bookProperty, getHotelDetails, getRoomsByHotel } from "../apis";
import { dateFormat } from "../utils";
import Loader from '../components/elements/Loader'
import LoginPopup from "../components/LoginPopup";
import RazorPay from "../components/RazorPay";

export default () => {
  const width = useWidth();
  const { isLoggedIn, customer } = useSelector( state => state.auth )
  const searchParams = useSearchParams();
  const [ isLogin, setIsLogin ] = useState(false)
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const [ razorpay, setRazorpay ] = useState({ amountToPay: 0, bookingId: null, orderId: null, open: false })

  const roomId = searchParams[0].get("roomId");
  const hotelId = searchParams[0].get("hotelId");
  const guest = searchParams[0].get("guest");
  const checkInDate = searchParams[0].get("checkInDate");
  const checkOutDate = searchParams[0].get("checkOutDate");


  const [ hotel,,loading ] = useFetch(getHotelDetails, {}, hotelId )
  const [ rooms,, ] = useFetch(getRoomsByHotel, [], hotelId)

  const room = useMemo(() => rooms.find( r =>  r.id == roomId ), [ rooms ])

  const bookhotel = async () => {
    try {

      if( !isLoggedIn ) return setIsLogin( true )
      setIsSubmitting( true )

      const data = {
        hotelId,
        roomId,
        // guest,
        checkInDate,
        checkOutDate,
        paymentMethod: "online",
        paidAmount: 1,
        discountPrice: 0
      }

      const response = await bookProperty(data)
      console.log('>>>>>>>>>', response)

      setRazorpay({ 
        amountToPay: response.amountToPay,
        bookingId: response.bookingId,
        orderId: response.razorpayOrderId
      })

      
    } catch (error) {
      console.log("error", error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
    <Loader loading={loading || isSubmitting } />
    {width < 992 && <MobileView hotel={hotel} room={room} />}
      {width > 992 && 
        <>
          <Navbar gradient />
          <Container>
            <section className="confirm-pay desktop-top-space pt-3">
              <h4 className="custom-text-color mb-3">
                <Icon icon={faArrowLeft} className="me-3" /> Confirm and pay
              </h4>
              <div className="row">
                {/* <div className="col-lg-8 col-md-12 p-0">
                  <div className="m-2 p-3 rounded-4 border border-1 mb-4">
                    <h4>Enter your details</h4>
                    <label
                      for="amenities-3"
                      className="d-flex align-items-center mb-1"
                    >
                      <input type="checkbox" id="amenities-3" onChange={ e => e.target.checked && reset({ firstname: "", lastname: "", email:"", mobile:"", state:"", city:"" })} />
                      <p className="ps-2 mb-0">
                        Make this booking for someone else.
                      </p>
                    </label>
                    <form onSubmit={handleSubmit( data => console.log('data', data))}>
                      <div className="row mt-3">
                        <div className="col-lg-6 col-sm-12">
                          <div className="m-2">
                            <label className="mb-2">First Name:</label>
                            <Input
                              placeHolder={"First Name"}
                              borderRadius="20px"
                              className="form-control borderless bg-transparent"
                              register={register("firstname", { required : true })}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-12">
                          <div className="m-2">
                            <label className="mb-2">Last Name</label>
                            <Input
                              placeHolder={"Last Name"}
                              borderRadius="20px"
                              className="form-control borderless bg-transparent"
                              register={register("lastname", { required : true })}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12 col-sm-12">
                          <div className="m-2">
                            <label className="mb-2">Email Address</label>
                            <Input
                              placeHolder={"Email Address"}
                              borderRadius="20px"
                              className="form-control borderless bg-transparent"
                              register={register("email", { required : true })}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12 col-sm-12">
                          <div className="m-2">
                            <label className="mb-2">Contact Number</label>
                            <Input
                              placeHolder={"Contact Number"}
                              borderRadius="20px"
                              className="form-control borderless bg-transparent"
                              type="number"
                              register={register("mobile", { required : true })}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-12">
                          <div className="m-2">
                            <label className="mb-2">State</label>
                            <select className=" form-control rounded-5 borderless bg-transparent" {...register("state", { required : true })} >
                              <option value={""}>Uttar Pradesh</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-12">
                          <div className="m-2">
                            <label className="mb-2">City</label>
                            <Input
                              placeHolder={"City"}
                              borderRadius="20px"
                              className="form-control borderless bg-transparent"
                              register={register("city", { required : true })}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <label
                    for="addguest"
                    className="d-flex align-items-center m-2"
                  >
                    <input type="checkbox" id="addguest" />
                    <p className="ps-2 mb-0">Add Another Guest</p>
                  </label>

                  <h4 className="my-4">User Permission</h4>
                  <label
                    for="consent"
                    className="d-flex align-items-center m-2"
                  >
                    <input type="checkbox" id="consent" />
                    <p className="ps-2 mb-0">
                      I consent to receive information about Dham and its
                      affiliates's good and services via email phone, text,
                      whatsapp and postal mail.
                    </p>
                  </label>
                </div> */}

                {/* <div className="col-lg-4 col-md-12 p-0">
                </div> */}
                  <div className="border border-1 rounded-4 p-3 m-2 bg-white">
                    <h4>Booking Details</h4>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="my-4" style={{ height: "350px" }}>
                          <img src={ hotel.files?.at(0)?.Url || Hotel} className="w-100 h-100 rounded-4 image-cover" />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <h5 className="custom-text-color">{ hotel.hotelName }</h5>
                        <p className="text-secondary fs-6">
                          <Icon
                            icon={faLocationDot}
                            className="text-saffron me-3"
                          />{" "}
                          { hotel.address }
                        </p>

                        <div>
                          <h5>Date:</h5>
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="fs-9 mb-2">Check In</p>
                              <p className="fs-6 mb-2 bold custom-text-color">
                                {dateFormat(checkInDate)}
                              </p>
                            </div>
                            <div>
                              <p className="fs-9 mb-2">Check Out</p>
                              <p className="fs-6 mb-2 bold custom-text-color">
                              {dateFormat(checkOutDate)}
                              </p>
                            </div>
                          </div>
                          <hr />
                        </div>

                        <div>
                          <h5>Guests:</h5>
                          <div>
                            <p className="fs-9 mb-2">Number of Guests</p>
                            <p className="fs-6 mb-2 bold custom-text-color">
                              { guest }
                            </p>
                          </div>
                          <hr />
                        </div>

                        <div>
                          <h5>Room:</h5>
                          <div>
                            <p className="fs-9 mb-2">Number of Rooms</p>
                            <p className="fs-6 mb-2 bold custom-text-color">
                              { room?.roomCategoryId?.name }
                            </p>
                          </div>
                          <hr />
                        </div>

                        <div>
                          <h5>Price details</h5>
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="fs-6 mb-2 bold custom-text-color">
                              ₹{ room?.offerPrice || 0} x { guest } per night
                            </p>
                            <p className="fs-6 mb-2 bold text-saffron">₹{ (room?.offerPrice || 0) * guest }</p>
                          </div>
                        </div>

                        <div className="d-flex justify-content-center">
                          <button className="search-button w-50 my-4" onClick={bookhotel}>
                            Confirm and pay
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
              </div>
            </section>
          </Container>

          {isLogin && <LoginPopup open={isLogin} setOpen={setIsLogin} cb={bookhotel} />}
          <RazorPay amount={razorpay.amountToPay} bookingId={razorpay.bookingId} orderId={razorpay.orderId} customer={customer} cb={(type, response) =>  setRazorpay({}) } />
        </>
      }
    </>
  );
};
